import { render } from "./LegalPage.vue?vue&type=template&id=31675a82&scoped=true&ts=true"
import script from "./LegalPage.vue?vue&type=script&lang=ts"
export * from "./LegalPage.vue?vue&type=script&lang=ts"

import "./LegalPage.vue?vue&type=style&index=0&id=31675a82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31675a82"]])

export default __exports__